import React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { useWelcomeBar } from './welcomeBarHooks';
import isEmpty from 'lodash/isEmpty';
import { zIndex } from 'constants/zIndex';
import { responsiveBreakpoints } from 'utils/utils';

const WelcomeBar = () => {
  const { theme, mobile, tablet, laptop, desktop, mainWidth } =
    responsiveBreakpoints();
  const { welcomeBarConfig, handleAppBarBtnClick, welcomeBarConfigLoading } =
    useWelcomeBar();

  if (!isEmpty(welcomeBarConfig) && !welcomeBarConfigLoading)
    return (
      <AppBar
        position={welcomeBarConfig.wel_bar_pos == 1 ? 'sticky' : 'relative'}
        // sx={{
        //   backgroundColor: `#${welcomeBarConfig.bg_color}`,
        //   height: `${welcomeBarConfig.bar_height}px`,
        //   opacity: welcomeBarConfig.opacity,
        // }}
        sx={[
          {
            hight: 'fit-content',
            zIndex: zIndex.welcomeBar,
            width: '100vw',
          },
          mobile
            ? {
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
              }
            : tablet
            ? {
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
              }
            : {
                padding: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: `#${welcomeBarConfig.bg_color ?? 'ffff'}`,
              },
        ]}
      >
        <Stack
          direction='row'
          spacing={2}
          justifyContent='center'
          alignItems='center'
          // sx={{
          //   height: '100%',
          // }}
          sx={{
            backgroundColor: `#${welcomeBarConfig.bg_color}`,
            height: `${welcomeBarConfig.bar_height}px`,
            opacity: welcomeBarConfig.opacity,
            padding: `${mobile ? '0px 5px 0px 5px' : '0px'}`,
            width: !mobile || !tablet ? mainWidth : '100%',
          }}
        >
          <Typography
            sx={[
              {
                color: `#${welcomeBarConfig.text_color}`,
                fontSize: `${mobile ? '8' : welcomeBarConfig.font_size}px`,
                fontFamily: `${welcomeBarConfig.font_type}, Avenir`,
                display: 'inline-grid',
                // width: '100%',
                height: `${welcomeBarConfig.bar_height}px`,
                opacity: `${welcomeBarConfig.opacity}`,
                '& p:first-child': {
                  textAlign: 'center',
                  display: 'flex',
                  overflow: 'hidden',
                  verticalAlign: 'middle',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: `${welcomeBarConfig.font_size}px`,
                  backgroundColor: `#${welcomeBarConfig.bg_color}`,
                  color: `#${welcomeBarConfig.text_color}`,
                  fontFamily: `${welcomeBarConfig.font_type}`,
                  margin: '0px',
                  whiteSpace: 'nowrap',
                },
                '& img': {
                  marginRight: '5px',
                  objectFit: 'contain',
                },
              },
              mobile
                ? {
                    '& img': {
                      width: '35px',
                      height: '30px',
                      objectFit: 'contain',
                      marginRight: '5px',
                    },
                  }
                : null,
            ]}
            id='welcome_bar_text'
          >
            {welcomeBarConfig.welcome_text}
          </Typography>
          {welcomeBarConfig.btn && (
            <Button
              href={`${welcomeBarConfig?.btn?.btn_url || '#'}`}
              variant='contained'
              size='medium'
              onClick={() =>
                handleAppBarBtnClick(
                  welcomeBarConfig.btn.btn_url,
                  welcomeBarConfig.btn.btn_new_win
                )
              }
              target={welcomeBarConfig.btn.btn_new_win ? '_blank' : '_self'}
              sx={{
                color: `#${welcomeBarConfig.btn.btn_text_color}`,
                backgroundColor: `#${welcomeBarConfig.btn.btn_color}`,
                height: '30px',
                fontSize: '12px',
                width: 'fit-content',
                whiteSpace: 'nowrap',
              }}
            >
              {welcomeBarConfig?.btn?.btn_txt}
            </Button>
          )}
        </Stack>
      </AppBar>
    );
  if (isEmpty(welcomeBarConfig) && welcomeBarConfigLoading)
    return <Skeleton variant='rectangular' height='40px' width='100%' />;
};

export default WelcomeBar;
